var dark = false
const Table = ({ children, className = '', isReport = false }) => {
    dark = isReport
    return (
        <div className={`max-w-full overflow-x-auto ${className}`}>
            <table className="w-full text-center table-auto">{children}</table>
        </div>
    )
}

Table.TR = ({ children, className = '', ...props }) => (
    <tr {...props} className={`hover:bg-gray dark:hover:bg-graydark ${className}`}>
        {children}
    </tr>
)

Table.TH = ({ isReport = false, print_format = false, children, pedding = 'py-1 px-2', className = '', ...props }) => (
    <th
        {...props}
        className={`${pedding} text-center ${dark ? 'border border-black' : 'border border-stroke dark:border-strokedark'} ${
            print_format
                ? 'font-bold text-black dark:text-white'
                : isReport
                  ? 'font-bold text-black light-header'
                  : 'font-medium text-white bg-primary dark:bg-secondary'
        } ${className}`}
    >
        {children}
    </th>
)

Table.TD = ({ children, pedding = 'py-1 px-2', className = '', ...props }) => (
    <td
        {...props}
        className={`${dark ? 'border border-black' : 'border border-stroke dark:border-strokedark'} items-center text-black dark:text-white ${pedding} ${className}`}
    >
        {children}
    </td>
)

export default Table
